import React from "react";

export function useLifecycle() {
    const lifecycle = React.useRef({
        isMounted: true,
    });

    React.useEffect(function add() {
        //console.log("lifecycle.current.isMounted = true;");
        lifecycle.current.isMounted = true;

        var lc = lifecycle.current;

        return function remove() {
            //console.log("lifecycle.current.isMounted = false;");
            lc.isMounted = false;
        }
    }, []);

    return lifecycle.current;
}
